import * as React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Form, useForm, Input, useNotify, Checkbox } from 'ebs-design';
import { ValidationError } from 'errors';

interface NomenclaturesFormToProps {
  id?: number;
  formId: string;
  getItem: any;
  onFinish: any;
  onClose: () => void;
}

export const FormNomenclaturesReasons: React.FC<NomenclaturesFormToProps> = ({
  id,
  getItem,
  formId,
  onFinish,
  onClose,
}) => {
  const { t } = useTranslation();
  const notify = useNotify();
  const queryClient = useQueryClient();
  const [form] = useForm();

  const { data } = useQuery([formId, { id }], getItem, {
    enabled: Boolean(id),
  });

  React.useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const mutation = useMutation(onFinish, {
    onError: (e) => {
      if (e instanceof ValidationError) {
        form.setFields(e.fields);
      } else {
        notify.error({ title: t('error.someThingIsWrong') });
        onClose();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([formId]);
      onClose();
      notify.success({ title: t('success.successDataSave') });
    },
  });

  const handleSubmit = (): void => {
    mutation.mutate({ ...form.getFieldsValue(), id });
  };
  return (
    <Form id={formId} form={form} onFinish={handleSubmit}>
      <Form.Field name="name" label={t('nomenclature.name')}>
        <Input />
      </Form.Field>

      <Form.Field name="is_default" valuePropName="checked" label={t('nomenclature.isDefault')}>
        <Checkbox />
      </Form.Field>
    </Form>
  );
};
